import React from 'react';
import { useRecordContext } from 'react-admin';
import { appointmentTypesFields } from '../../appointment-types.model';

/**
 * Custom field to format appointment length in minutes
 */
const LengthField = ({ 
    source = appointmentTypesFields.length,
    label = 'Length',
    sortable = true,
    addLabel = true,
}) => {
    const record = useRecordContext();
    
    if (!record) {
        return null;
    }
    
    const minutes = record[source];
    
    if (!minutes && minutes !== 0) {
        return <span>-</span>;
    }
    
    return <span>{minutes} min</span>;
};

export default LengthField;

